// src/vistas/EstudianteHome.js
import React, { useEffect, useState } from 'react';
import { Alert, Card, Button } from 'react-bootstrap';
import { useAuth } from '../servicios/store';
import { obtenerContenidosPorIds, suscribirCertificadosActivos } from '../servicios/consultas';
import BarraNavegacion from '../componentes/BarraNavegacion';
import Tarjeta from '../componentes/Tarjeta';
import Loader from '../componentes/Loader';
import './EstudianteHome.css';

const EstudianteHome = () => {
  const { currentUser, logout } = useAuth(); // <-- Añade logout aquí
  const [contenidos, setContenidos] = useState([]);
  const [certificados, setCertificados] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let isMounted = true;
    let unsubscribeCertificados = () => {};
  
    const cargarDatos = async () => {
      try {
        if (!isMounted) return;
        
        setCargando(true);
        setError(null);
  
        // Resetear datos previos al cargar nuevos
        if (!currentUser?.contenidos) {
          setContenidos([]);
          setCertificados([]);
        }
  
        // Cargar contenidos solo si hay IDs válidos
        if (currentUser?.contenidos?.length > 0) {
          const contenidosData = await obtenerContenidosPorIds(currentUser.contenidos);
          if (isMounted) setContenidos(contenidosData);
        }
  
        // Manejo de suscripción con control de permisos
        if (currentUser?.uid) {
          unsubscribeCertificados = suscribirCertificadosActivos(
            currentUser.uid,
            (error, nuevosCertificados) => {
              if (!isMounted) return;
              
              if (error === 'SESION_EXPIRADA') {
                setError('Sesión expirada. Redirigiendo...');
                setTimeout(() => logout(), 2000); // Cierre de sesión seguro
                return;
              }
              
              if (error) {
                setError(`Error en certificados: ${error}`);
                setCargando(false);
                return;
              }
  
              setCertificados(nuevosCertificados);
              setCargando(false);
            }
          );
        }
  
      } catch (error) {
        if (isMounted) {
          setError(error.message);
          setCargando(false);
        }
      }
    };
  
    if (currentUser?.estado === 'activo') {
      cargarDatos();
    }
  
    // Limpieza completa al desmontar o cambiar usuario
    return () => {
      isMounted = false;
      unsubscribeCertificados();
      setContenidos([]);
      setCertificados([]);
    };
  }, [currentUser]); // Asegurar dependencia actualizada
  
  if (cargando) return <Loader fullscreen />;

  return (
    <div className="estudiante-container">
      <BarraNavegacion />
      
      <div className="contenido-principal p-4">
        <h2 className="mb-4">Bienvenido, {currentUser?.nombre}</h2>
        
        {error && <Alert variant="danger" className="mb-4">{error}</Alert>}

        {/* Sección de Cursos */}
        <section className="mb-5">
          <h3 className="mb-4">Tus Cursos Asignados</h3>
          
          {contenidos.length === 0 ? (
            <Alert variant="info">
              Aún no tienes cursos asignados. Contacta al administrador.
            </Alert>
          ) : (
            <div className="cursos-grid">
              {contenidos.map(contenido => (
                <div key={contenido.id} className="curso-container">
                  <h3 className="curso-titulo mb-3">{contenido.curso}</h3>
                  <div className="tarjetas-container">
                    {contenido.contenido?.map((tarjeta, index) => (
                      <Tarjeta
                        key={index}
                        titulo={tarjeta.tituloTarjeta}
                        descripcion={tarjeta.descripcionTarjeta}
                        imagen={tarjeta.imagen}
                        enlace={tarjeta.enlace}
                      />
                    ))}
                  </div>
                </div>
              ))}
            </div>
          )}
        </section>

        {/* Sección de Certificados en Tiempo Real */}
        <section className="certificados-section">
          <h3 className="mb-4">Mis Certificados</h3>
          
          {certificados.length === 0 ? (
            <Alert variant="info">
              No tienes certificados activos actualmente.
            </Alert>
          ) : (
            <div className="certificados-grid">
              {certificados.map(certificado => (
                <Card key={certificado.id} className="certificado-card">
                  <Card.Body>
                    <Card.Title>{certificado.curso}</Card.Title>
                    <Card.Subtitle className="mb-2 text-muted">
                      {certificado.institucion}
                    </Card.Subtitle>
                    <Card.Text className="mb-2">
                      <small>Código: {certificado.codigoCert}</small>
                    </Card.Text>
                    <Card.Text>
                      <small className="text-muted">
                        Emitido el: {new Date(certificado.fechaCreacion?.seconds * 1000).toLocaleDateString()}
                      </small>
                    </Card.Text>
                    <Button 
                      variant="success" 
                      href={certificado.urlDescarga} 
                      target="_blank"
                      className="w-100 btn-descargar"
                    >
                      <i className="bi bi-download me-2"></i>
                      Descargar Certificado
                    </Button>
                  </Card.Body>
                </Card>
              ))}
            </div>
          )}
        </section>
      </div>
    </div>
  );
};

export default EstudianteHome;